import React from 'react';

export const StartPoint = () => (
  <div className="start-point-marker">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 58" width="30" height="28">
      <g>
        <path className="shp0" d="M57 5L5 5L5 34L57 53L57 5Z"/>
        <path className="shp1" d="M34 16.01L43.99 24L34 31.99L34 16.01ZM24 16.01L33.99 24L24 31.99L24 16.01Z"/>
      </g>
    </svg>
  </div>
);
